import React from "react";

import { Clear } from "@churchofjesuschrist/eden-icons";

import withStrings from "../../../utils/strings/with-strings";
import useManagedStrings from "../../../utils/use-managed-strings";
import {
  ColoredButton,
  StyledWrapper,
  TextHolder,
} from "../button-styled-components";

const stringGroups = [{ name: "shared", keys: ["clear"] }];

const StringsButton = ({ onClick, strings, ...others }) => {
  const { managedStrings: useStrings } = useManagedStrings(stringGroups);
  return (
    <ColoredButton {...others} onClick={onClick}>
      <StyledWrapper>
        <Clear />
      </StyledWrapper>
      <TextHolder>{useStrings.clear}</TextHolder>
    </ColoredButton>
  );
};
const ClearButton = ({ onClick, ...others }) => {
  const Stringified = withStrings(StringsButton);
  return <Stringified onClick={onClick} {...others} />;
};

export default ClearButton;
